import * as React from 'react';
import styles from './PlayButton.css';
import { PlayIcon } from './assets';
import { jsx as _jsx } from "react/jsx-runtime";
export function PlayButton(_ref) {
  var onClick = _ref.onClick;
  return /*#__PURE__*/_jsx("button", {
    onClick: onClick,
    className: styles['button'],
    children: /*#__PURE__*/_jsx(PlayIcon, {})
  });
}